// extracted by mini-css-extract-plugin
export var banner = "banner-module--banner--1JT3s";
export var bannerImgContainer = "banner-module--bannerImgContainer--2EuYd";
export var bannerSpecialInfoCTA = "banner-module--bannerSpecialInfoCTA--cDF6e";
export var bannerCTAcontainer = "banner-module--bannerCTAcontainer--xR4CN";
export var cta = "banner-module--cta--2K9Hr";
export var ctaButton = "banner-module--ctaButton--1qwfg";